<div class="demo-app">
    <div class="demo-app-main">
        <full-calendar #calendar class="tw-absolute tw-w-full" [options]='calendarOptions()'>
        </full-calendar>
    </div>
</div>